import "../../../../styles/page/order.scss";

import ClaimProductDisplayCard from "./ClaimProductDisplayCard.jsx";
import ContentWrapper from "../../../common/components/ContentWrapper.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import SearchBar from "../../components/order/SearchBar.jsx";
import {scssVariables} from "../../../common/util/config.jsx";

class ClaimProductPage extends React.PureComponent {
    constructor(props){
        super(props);
        
        this.calculateProductDisplayHeight = this.calculateProductDisplayHeight.bind(this);
        this.calculateProductDisplayWidth = this.calculateProductDisplayWidth.bind(this);
        this.onEditFilter = this.onEditFilter.bind(this);
        this.loadMoreSearchResaults = this.loadMoreSearchResaults.bind(this);
    }
    
    calculateProductDisplayHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;

        if( deviceType==="xs" ) {
            //shopping cart in menu form
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        } else {
            //searchbar height
            productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        }
        //product display padding
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }
    calculateProductDisplayWidth() {
        const {
            deviceType,
            width,
        } = this.props;

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";

        let productDisplayWidth = width;
        if( deviceType==="xs" ) {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        } else {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]);//no padding on the right side(Attached to it)
            //page padding
            productDisplayWidth -= parseInt(isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth);
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        }

        return productDisplayWidth;
    }

    onEditFilter(...args) {
        const {
            editQueryFilter,
            flowControl,
        } = this.props;
        flowControl(async () => {
            await editQueryFilter(...args);
        });
    }

    loadMoreSearchResaults() {
        const {
            deviceType,
            loadMoreSearchedProducts,
            invoiceId,
            currentView

        } = this.props;
        const productDisplayHeight = this.calculateProductDisplayHeight();
        const rowsToLoad = (Math.floor(productDisplayHeight/parseInt(scssVariables.productItemHeight))+2);
        // rowsToLoad * itemsPerRow
        switch(deviceType){
        case "xs":
        case "sm":
            loadMoreSearchedProducts( rowsToLoad*2, currentView==="invoice"? invoiceId : 0 );
            break;
        case "md":
            loadMoreSearchedProducts( rowsToLoad*4,  currentView==="invoice"? invoiceId : 0  );
            break;
        case "lg":
            loadMoreSearchedProducts( rowsToLoad*6,  currentView==="invoice"? invoiceId : 0  );
            break;
        default:
            loadMoreSearchedProducts( rowsToLoad*8,  currentView==="invoice"? invoiceId : 0  );
            break;
        }
    }

    render(){
        const {
            clearQuery,
            deviceType,
            localization,
            setOrderProductView,
            activeList,
            invoiceLines,
            addRemoveSalesUnitToClaim,
            addRemoveWarehouseUnitToClaim,
            productView,
            height,
            editQueryFilter,
            productQuery,
            titleTabs,
            cart,
            onClickShowProducts,
            currentView,
            setModal,
            setDropDown,
            filter,
            historyFilter,
        } = this.props;

        const productDisplayHeight = this.calculateProductDisplayHeight();
        const productDisplayWidth = this.calculateProductDisplayWidth();

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";
        const historySearchString = historyFilter ?  historyFilter.searchString : "";

        return deviceType=="xs" ? (
            <ContentWrapper height={height}>
                <div style={{display:"flex", height:"100%"}} >
                    <ClaimProductDisplayCard 
                        localization={localization}
                        setOrderProductView={setOrderProductView}
                        addRemoveSalesUnitToClaim={addRemoveSalesUnitToClaim}
                        addRemoveWarehouseUnitToClaim={addRemoveWarehouseUnitToClaim}
                        productView={productView}
                        height={productDisplayHeight}
                        width={productDisplayWidth}
                        loadMoreSearchResaults={this.loadMoreSearchResaults}
                        productQuery={productQuery}
                        //productQuery={{ ...productQuery, filter: { ...filter, searchString: historySearchString}}}
                        deviceType={deviceType}
                        activeOrder={activeList}
                        invoiceLines={invoiceLines}
                        editQueryFilter={editQueryFilter}
                        currentView={currentView}
                        setModal={setModal}
                        setDropDown={setDropDown}
                        //initialFilter={historySearchString ? true: false}
                        initialFilter={historySearchString}
                    />
                    {cart}
                </div>
            </ContentWrapper>
        ) : (
            <ContentWrapper height={height} paddingRight={false}>
                <div style={{display:"flex", height:"100%"}} >
                    <div className="my-list-left-backgorund" >
                        {titleTabs}
                        <SearchBar
                            clearQuery={clearQuery}
                            localization={localization}
                            useFilter={true}
                            filter={{
                                ...productQuery.filter,
                                ...filter
                            }}
                            productQuery={productQuery}
                            onEdit={this.onEditFilter}
                            deviceType={deviceType}
                            onClickShowProducts={onClickShowProducts}
                            usingSubmit={true}
                            setModal={setModal}
                            disabled={false}
                            setDropDown={setDropDown}
                            initialFilter={historySearchString}
                        />
                        <ClaimProductDisplayCard 
                            localization={localization}
                            setOrderProductView={setOrderProductView}
                            addRemoveSalesUnitToClaim={addRemoveSalesUnitToClaim}
                            addRemoveWarehouseUnitToClaim={addRemoveWarehouseUnitToClaim}
                            editQueryFilter={editQueryFilter}
                            productView={productView}
                            height={productDisplayHeight}
                            width={productDisplayWidth}
                            loadMoreSearchResaults={this.loadMoreSearchResaults}
                            productQuery={productQuery}
                            deviceType={deviceType}
                            activeOrder={activeList}
                            invoiceLines={invoiceLines}
                            currentView={currentView}
                            setModal={setModal}
                            setDropDown={setDropDown}
                        />
                    </div>
                    <div style={{height:"100%", flex: `0 0 ${isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth}`}} >
                        {cart}
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

ClaimProductPage.propTypes = {
    //Required
    clearQuery: PropTypes.func.isRequired,
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    setOrderProductView: PropTypes.func.isRequired,
    productView: PropTypes.object.isRequired,
    activeList: PropTypes.object.isRequired,
    invoiceLines: PropTypes.array.isRequired,
    addRemoveSalesUnitToClaim: PropTypes.func.isRequired,
    addRemoveWarehouseUnitToClaim: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    loadMoreSearchedProducts: PropTypes.func.isRequired,
    productQuery: PropTypes.object.isRequired,
    cart: PropTypes.node.isRequired,
    onClickShowProducts: PropTypes.func.isRequired,
    flowControl: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    //What tab should be shown on componentMount
    currentView: PropTypes.string,
    //What filter should be used
    filter: PropTypes.object,
    //A node containing titletabs
    titleTabs: PropTypes.node,
    invoiceId: PropTypes.number,
    historyFilter: PropTypes.object,
};

ClaimProductPage.defaultProps = {
    currentView: "all",
};

export default ClaimProductPage;